require('./sass/app.sass')
Backbone.$ = require('jquery')
Middleware = require("lib/middleware")
ErrorLogger = require("lib/error-logger.ts")


Application =
  actions:   Middleware.actions
  action:    Middleware.action
  publish:   Middleware.publish
  subscribe: Middleware.subscribe
  
  initialize: (platform, isPlayer) ->
    @isPlayer = isPlayer
    @platform = platform
    window.iostap.initialize(allowDefault: -> true)
    Middleware.initialize(platform)

    # Re-initialize iostap after iframe is properly sized
    # This fixes issues where innerWidth/innerHeight are 0 on initial load
    window.addEventListener 'load', =>
      window.setTimeout =>
        window.iostap.set
          maxDistance: Math.max(Math.pow(window.innerHeight * window.innerWidth, 0.35), 50)
      , 100

    require("lib/i18n").initialize("en")

    # Require the router during initialization to avoid infinite requiring
    # The router is a singleton that handles app-wide navigation
    Router  = require("lib/router")
    @router = new Router()
    
    # Initialize the error logger
    @errorLogger = new ErrorLogger({ isScorm: platform == "scorm", disable: platform == "scorm" || isPlayer })

    Analytics = Middleware.actions("Analytics")
    Analytics.startTracking()

    Lesson = Middleware.actions("Lesson")
    Lesson.open()

    # Everything is now loaded, so start Backbone.history 
    # Make sure to not pushState into the history 
    #  to not mess up the iframe parent history
    Backbone.history.start({ pushState: false})
    console.log("HISTORY START")

# Application is a global variable to be able to access it outside of the window
module.exports = window.Application = Application